// extracted by mini-css-extract-plugin
module.exports = {"headingContainer":"heading_headingContainer__WUhSs","heading":"heading_heading__H0oEv","h3":"heading_h3__9yeWT"};